import React from 'react';
import { bool, func, number, string } from 'prop-types';

import styles from './styles.module.scss';
import useTips from './useTips';

function TipAmountSelection({ className, onSetIndex, subtotal, onResetTip, noCustomTip = false }) {
  const { componentOrder } = useTips({ onSetIndex, subtotal, onResetTip, noCustomTip });
  return (
    <div className={`row middle ${styles.tipAmountContainer} ${styles.tipAmountItem} ${className}`}>
      {componentOrder.map(component => (
        <React.Fragment key={component.index}>{component}</React.Fragment>
      ))}
    </div>
  );
}

TipAmountSelection.propTypes = {
  onResetTip: func.isRequired,
  className: string,
  noCustomTip: bool,
  subtotal: number,
  onSetIndex: func
};

export default TipAmountSelection;
